import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from "./Footer";
import Header from "./Header";
import PlaneIco1 from './assets/img/PlaneIco-1.png';
import captchaCode from './assets/img/captchaCode.png';
import captchaImg from './assets/img/captchaImg.png';
import saleImg from './assets/img/saleImg.png';
import QRImg from './assets/img/QRImg.png';
import giftImg from './assets/img/giftImg.png';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { saveFlightBooking } from "../services/services";
import arrowWhiteIco from './assets/img/arrowWhiteIco.png';
import MasterCard from './assets/img/MasterCard.png';
import payCode from './assets/img/payCode.png';
import downArrow from './assets/img/downArrow.png';

const FlightsPay = () => {
    const navigate = useNavigate();

    const [passengerType, setPassengerType] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [nationality, setNantionality] = useState('')
    const [gender, setGender] = useState('')
    const [dateOfBirth, setDateOfBirth] = useState('')
    const [passportNumber, setPassportNumber] = useState('')
    const [passportExpDate, setPassportExpDate] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [isOpen, setIsOpen] = useState(true); // Default to open
    const [selectedCoupon, setSelectedCoupon] = useState("INSTANT");

    useEffect(() => {
        // Initialize Flatpickr
        flatpickr("#datepicker", {
            dateFormat: "d/m/Y",
            allowInput: true,
            locale: {
                firstDayOfWeek: 0,
                weekdays: {
                    shorthand: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                    longhand: [
                        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
                    ]
                }
            }
        });

        // Add event listener for the button
        const button = document.getElementById("addPassengerButton");
        const formDiv = document.querySelector(".addPassengerContentWrap");

        if (button && formDiv) {
            button.addEventListener("click", () => {
                formDiv.style.display = "block";
            });
        }

        // Cleanup function to remove event listener
        return () => {
            if (button) {
                button.removeEventListener("click", () => {
                    formDiv.style.display = "block";
                });
            }
        };
    }, []); // Run only once when the component mounts

    const saveFlightBookingDetails = async () => {

        let data = {}
        let flightBooking = {
            "uniqueTransId": "NZ23479523302253652",
            "itemCodeRef": "TloyMzQ3OTUxMjk0MjEwNDk0LTYzODY3MzY3OTYxMDgxNDEzMXxWL0Jhd01UcVdES0FJVndvQUFBQUFBPT18R2FsaWxlb3wxRy1CRA==",
            "priceCodeRef": "TloyMzQ3OTUyMzMwMjI1MzY1Mi02Mzg2NzM3MDg3OTY4MDIwNDF8Vi9CYXdNVHFXREtBY3o4cEFBQUFBQT09fEdhbGlsZW98MUctQkQ==",
            "totalAmount": "850",
            "currency": "USD",
            "bookingDate": "09/12/2024" // Example static date in 'YYYY-MM-DD' format
        }
        let contactInfo = {
            "email": email,
            "phone": phoneNumber,
            "phoneCountryCode": "+1"
        }
        let passengers = [{
            "passengerType": passengerType,
            "title": "Mr",
            "firstName": firstName,
            "lastName": lastName,
            "gender": gender,
            "dateOfBirth": dateOfBirth,
            "passportNumber": passportNumber,
            "passportExpiryDate": passportExpDate,
            "nationality": nationality,
            "isWheelchair": false,
            "issuingCountry": "US",
            "phoneCountryCode": "+1",
            "phone": "1234567890",
            "email": "john.doe@example.com",
            "meal": {
                "code": "VGML",
                "description": "Vegetarian Meal"
            },
            "extraBaggage": {
                "code": "EXBG",
                "description": "Extra 20kg baggage"
            }
        }]

        data = {
            flightBooking: flightBooking,
            contactInfo: contactInfo,
            passengerDetails: passengers,
            "totalAmount": "850",
            "currancy": "USD",
            "bookingDate": ""
        }
        console.log(dateOfBirth)
        console.log(passportExpDate)
        await saveFlightBooking(data, onSuccess, onError)
    }
    const onSuccess = (response) => {
        // window.location.reload()
        navigate("/FlightDigitalTicket");
    }
    const onError = (error) => {
        console.log(error)
    }

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };


    return (
        <>
            <Header></Header>
            <div className="mainContent">
                <div className="flightProgressWrap">
                    <div className="flightProgressInner">
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-xl-6">
                                    <ul>
                                        <li>
                                            <div className="itemWrap completed">
                                                <div className="noWrap">
                                                    <div className="icoWrap">
                                                        <img src={arrowWhiteIco} className="img-fluid" alt="" />
                                                    </div>
                                                </div>
                                                <div className="dataWrap">
                                                    <p>Flight Selection</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="itemWrap active">
                                                <div className="noWrap">
                                                    <h2>2</h2>
                                                </div>
                                                <div className="dataWrap">
                                                    <p>Flight Selection</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="itemWrap">
                                                <div className="noWrap">
                                                    <h2>3</h2>
                                                </div>
                                                <div className="dataWrap">
                                                    <p>Flight Selection</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="itemWrap">
                                                <div className="noWrap">
                                                    <h2>4</h2>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flightReservWrap">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="titleWrap">
                                    <h2>Flight Reservation/Booking Passenger Details</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-9">
                                <div className="leftPannelWrap">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="flightReservDeparWrap marBtmLess">
                                                <div className="row justify-content-center">
                                                    <div className="col-xl-4 col-sm-4 col-12">
                                                        <div className="depRetWrap">
                                                            <h3>Departure</h3>
                                                            <ul>
                                                                <li>
                                                                    <div className="itemWrap">
                                                                        <div className="boxWrap">
                                                                            <h2>14:00</h2>
                                                                            <p>Sun, 29 Jan</p>
                                                                        </div>
                                                                        <div className="boxWrap">
                                                                            <h2>14:00</h2>
                                                                            <p>Sun, 19 Jan</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="itemWrap">
                                                                        <div className="boxWrap boxBigWrap">
                                                                            <p>9hr 50min</p>
                                                                            <p className="clrTxt">Non-Transit</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="itemWrap midIcoWrap">
                                                                        <div className="icoWrap roundIco"></div>
                                                                        <div className="icoWrap roundIco"></div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="itemWrap">
                                                                        <div className="boxWrap">
                                                                            <h2>BOM</h2>
                                                                            <p>Airport Name</p>
                                                                        </div>
                                                                        <div className="boxWrap">
                                                                            <h2>GOA</h2>
                                                                            <p>Airport Name</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-7 col-sm-8 col-12">
                                                        <div className="depRetWrap twoWayDepRetWrap">
                                                            <div className="swipeWrap">
                                                                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M5 5H19L15 1M15 9H1L5 13" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            </div>
                                                            <h3>Return</h3>
                                                            <ul>
                                                                <li>
                                                                    <div className="itemWrap">
                                                                        <div className="boxWrap">
                                                                            <h2>14:00</h2>
                                                                            <p>Sun, 29 Jan</p>
                                                                        </div>
                                                                        <div className="boxWrap">
                                                                            <h2>14:00</h2>
                                                                            <p>Sun, 19 Jan</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="itemWrap">
                                                                        <div className="boxWrap boxBigWrap">
                                                                            <p>9hr 50min</p>
                                                                            <p className="clrTxt">Non-Transit</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="itemWrap midIcoWrap">
                                                                        <div className="icoWrap roundIco roundIcoLeft"></div>
                                                                        <div className="lineWrap">
                                                                            <p>2hr 10min</p>
                                                                            <p className="contentTxt">4hr 10min</p>
                                                                            <p>3hr 10min</p>
                                                                        </div>
                                                                        <div className="icoWrap roundIco roundIcoRight"></div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="itemWrap">
                                                                        <div className="boxWrap">
                                                                            <h2>BOM</h2>
                                                                            <p>Airport Name</p>
                                                                        </div>
                                                                        <div className="boxWrap">
                                                                            <h2>GOA</h2>
                                                                            <p>Airport Name</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="travellersWrap">
                                                <div className="topWrap">
                                                    <h2>Travellers</h2>
                                                    <div className="ctaWrap">
                                                        <button className="btn">See all</button>
                                                        <button className="btn">Hide
                                                            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M5.45059 0.884496L1.10617 5.22892C0.616204 5.71888 0.963217 6.55664 1.65613 6.55664H10.345C11.0379 6.55664 11.3849 5.71888 10.8949 5.22892L6.55051 0.884495C6.24678 0.58076 5.75432 0.58076 5.45059 0.884496Z" fill="#6E7491" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="tblWrap">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>Jack Wills</td>
                                                                <td>28 Y.O</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Jack Wills</td>
                                                                <td>28 Y.O</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Jack Wills</td>
                                                                <td>28 Y.O</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Jack Wills</td>
                                                                <td>28 Y.O</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="paymentModeWrap">
                                                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                                    <li class="nav-item" role="presentation">
                                                        <button class="nav-link active" id="pills-PayCreditDebit-tab" data-bs-toggle="pill" data-bs-target="#pills-PayCreditDebit" type="button" role="tab" aria-controls="pills-PayCreditDebit" aria-selected="true">Pay with Credit & Debit Card </button>
                                                    </li>
                                                    <li class="nav-item" role="presentation">
                                                        <button class="nav-link" id="pills-PayUPIID-tab" data-bs-toggle="pill" data-bs-target="#pills-PayUPIID" type="button" role="tab" aria-controls="pills-PayUPIID" aria-selected="false">Pay with  UPI ID / QR Code</button>
                                                    </li>
                                                </ul>
                                                <div class="tab-content" id="pills-tabContent">
                                                    <div class="tab-pane fade show active" id="pills-PayCreditDebit" role="tabpanel" aria-labelledby="pills-PayCreditDebit-tab">
                                                        <div class="boxWrap">
                                                            <form>
                                                                <ul class="formList">
                                                                    <li class="full">
                                                                        <div class="inputField">
                                                                            <label>Card Number *</label>
                                                                            <div class="payMode">
                                                                                <input placeholder="xxxx xxxx xxxx xxxx" />
                                                                                <img src={MasterCard} className="img-fluid" alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li class="fourth">
                                                                        <div class="inputField">
                                                                            <label>Expiry date *</label>
                                                                            <input placeholder="Month" />
                                                                        </div>
                                                                    </li>
                                                                    <li class="fourth">
                                                                        <div class="inputField">
                                                                            <label class="clrTansparent">Year</label>
                                                                            <input placeholder="Year" />
                                                                        </div>
                                                                    </li>
                                                                    <li class="half">
                                                                        <div class="inputField">
                                                                            <label>CVV/CVC *</label>
                                                                            <input placeholder="xxxx xxxx xxxx xxxx" />
                                                                        </div>
                                                                    </li>
                                                                    <li class="full">
                                                                        <div class="inputField">
                                                                            <label>Card holder name *</label>
                                                                            <input placeholder="Name on card" />
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </form>
                                                            <div class="discountWrap">
                                                                <div class="icoWrap">
                                                                    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M10.4066 7.95981V11.8536M10.4066 14.7739V14.7837M19.1676 10.8801C19.1676 15.7187 15.2452 19.6411 10.4066 19.6411C5.56806 19.6411 1.64563 15.7187 1.64563 10.8801C1.64563 6.04157 5.56806 2.11914 10.4066 2.11914C15.2452 2.11914 19.1676 6.04157 19.1676 10.8801Z"
                                                                            stroke="#40C057" stroke-width="2.92033" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </div>
                                                                <div class="dataWrap">
                                                                    <h2>Discount</h2>
                                                                    <p>Hey' you have a <span>$2,560</span> discount using coupon code applied.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade" id="pills-PayUPIID" role="tabpanel" aria-labelledby="pills-PayUPIID-tab">
                                                        <div class="PayUPIIDWrap">
                                                            <div class="row">
                                                                <div class="col-md-6 col-sm-6 col-8">
                                                                    <form>
                                                                        <ul class="formList">
                                                                            <li class="halfLg">
                                                                                <div class="inputField">
                                                                                    <label>Enter UPI ID</label>
                                                                                    <div class="inputIco">
                                                                                        <input placeholder="24515478145@ybl" />
                                                                                        <div class="icoWrap">
                                                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                <path d="M10 0C9.782 0 9.568 0.00200011 9.358 0.00500011L8.742 0.0220001L8.443 0.0350001L7.864 0.069L7.311 0.115C2.526 0.579 0.579 2.526 0.115 7.311L0.069 7.864L0.0350001 8.443C0.0300001 8.541 0.0250001 8.641 0.0220001 8.742L0.00500011 9.358L0.000999928 9.676L0 10C0 10.218 0.00200011 10.432 0.00500011 10.642L0.0220001 11.258L0.0350001 11.557L0.069 12.136L0.115 12.689C0.579 17.474 2.526 19.421 7.311 19.885L7.864 19.931L8.443 19.965C8.541 19.97 8.641 19.975 8.742 19.978L9.358 19.995L10 20L10.642 19.995L11.258 19.978L11.557 19.965L12.136 19.931L12.689 19.885C17.474 19.421 19.421 17.474 19.885 12.689L19.931 12.136L19.965 11.557C19.97 11.459 19.975 11.359 19.978 11.258L19.995 10.642L20 10L19.995 9.358L19.978 8.742L19.965 8.443L19.931 7.864L19.885 7.311C19.421 2.526 17.474 0.579 12.689 0.115L12.136 0.069L11.557 0.0350001C11.4574 0.0301352 11.3577 0.0258018 11.258 0.0220001L10.642 0.00500011L10.324 0.000999928L10 0ZM12.293 7.293C12.473 7.11365 12.7144 7.00953 12.9684 7.00177C13.2223 6.99402 13.4697 7.08321 13.6603 7.25125C13.8508 7.41928 13.9703 7.65355 13.9944 7.90647C14.0185 8.1594 13.9454 8.41201 13.79 8.613L13.707 8.707L9.707 12.707C9.53481 12.8792 9.30571 12.9826 9.06268 12.9979C8.81966 13.0132 8.5794 12.9393 8.387 12.79L8.293 12.707L6.293 10.707C6.11365 10.527 6.00953 10.2856 6.00177 10.0316C5.99402 9.77767 6.08321 9.53029 6.25125 9.33972C6.41928 9.14916 6.65355 9.02969 6.90647 9.0056C7.1594 8.98151 7.41201 9.05459 7.613 9.21L7.707 9.293L9 10.585L12.293 7.293Z" fill="#2BD11C" />
                                                                                            </svg>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p class="ErrorMsg">Invalid UPI ID</p>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </form>
                                                                </div>
                                                                <div class="col-md-6 col-sm-6 col-4">
                                                                    <div class="qrCodeWrap">
                                                                        <div class="imgWrap">
                                                                            <img src={payCode} className="img-fluid" alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="rightResPannelWrap mobRightPannelWrap">
                                    <div className="offers-container itemWrap">
                                        <h3>Offers for you</h3>
                                        <input
                                            type="text"
                                            className="coupon-input"
                                            placeholder="Coupon code Redeem here"
                                        />
                                        <div className="offer-item">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="coupon"
                                                    value="INSTANT"
                                                    checked={selectedCoupon === "INSTANT"}
                                                    onChange={() => setSelectedCoupon("INSTANT")}
                                                />
                                                <span className="custom-radio"></span>
                                            </label>
                                            <div className="offer-details active">
                                                <h4>INSTANT <span className="discount">$32 Off</span></h4>
                                                <p>
                                                    Coupon Applied. You Will Get An Instant Discount Of $32 And
                                                    Receive A Flight Code For Flat 20% Off! <a href="#">Know More</a>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="offer-item">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="coupon"
                                                    value="JGCODE50"
                                                    checked={selectedCoupon === "JGCODE50"}
                                                    onChange={() => setSelectedCoupon("JGCODE50")}
                                                />
                                                <span className="custom-radio"></span>
                                                <div className="offer-details">
                                                    <h4>JGCODE50 <span className="discount">$50 Off</span></h4>
                                                    <p>
                                                        Coupon Applied. You Will Get An Instant Discount Of $32 And
                                                        Receive A Flight Code For Flat 20% Off! <a href="#">Know More</a>
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <a href="#" className="viewAll">View All Offers
                                            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.54941 6.11551L10.8938 1.77109C11.3838 1.28112 11.0368 0.443361 10.3439 0.443361L1.65503 0.44336C0.962118 0.44336 0.615105 1.28112 1.10507 1.77108L5.44949 6.11551C5.75322 6.41924 6.24568 6.41924 6.54941 6.11551Z" fill="#003DF6" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="itemWrap fareSumWrap">
                                        <div className="topFareTTlWrap marBtm">
                                            <h2>Fare Summary</h2>
                                            <p>4 Travellers</p>
                                        </div>
                                        <div class="accordion" id="accordionFlushExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#flush-collapseOne" aria-expanded="true" aria-controls="flush-collapseOne">
                                                        <h3>
                                                            <img src={downArrow} className="img-fluid" alt="" />
                                                            Base fare
                                                        </h3>
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseOne" class="accordion-collapse collapse show">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <p>Adult(s) (1 x $110)</p>
                                                                <p>$110</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#flush-collapseTwo" aria-expanded="true" aria-controls="flush-collapseTwo">
                                                        <h3>
                                                            <img src={downArrow} className="img-fluid" alt="" />
                                                            Taxes, Fee and Surcharges
                                                        </h3>
                                                        <h3>$23</h3>
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseTwo" class="accordion-collapse collapse show">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <p>Airline Taxes and Surcharges</p>
                                                                <p>$17.3</p>
                                                            </li>
                                                            <li>
                                                                <p>Service Fee</p>
                                                                <p>$6</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#flush-collapseThree" aria-expanded="true" aria-controls="flush-collapseThree">
                                                        <h3>
                                                            <img src={downArrow} className="img-fluid" alt="" />
                                                            Other Services
                                                        </h3>
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseThree" class="accordion-collapse collapse show">
                                                    <div class="accordion-body">
                                                        <ul>
                                                            <li>
                                                                <p>Charity</p>
                                                                <p>$5</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btmTtlWrap">
                                            <h2>Total Amount</h2>
                                            <h2>$139</h2>
                                        </div>
                                        <div className="bottomNoteWrap">
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.7402 13.5273C12.4144 13.8599 12.0254 14.1242 11.5961 14.3046C11.1668 14.4849 10.7059 14.5779 10.2402 14.5779C9.7746 14.5779 9.31364 14.4849 8.88436 14.3046C8.45508 14.1242 8.06611 13.8599 7.74023 13.5273M6.24023 7.52734L8.24023 9.52734M8.24023 7.52734L6.24023 9.52734M12.2402 7.52734L14.2402 9.52734M14.2402 7.52734L12.2402 9.52734M1.24023 10.5273C1.24023 11.7092 1.47303 12.8796 1.92532 13.9715C2.37761 15.0634 3.04055 16.0556 3.87627 16.8913C4.712 17.727 5.70415 18.39 6.79608 18.8423C7.88801 19.2946 9.05834 19.5273 10.2402 19.5273C11.4221 19.5273 12.5925 19.2946 13.6844 18.8423C14.7763 18.39 15.7685 17.727 16.6042 16.8913C17.4399 16.0556 18.1029 15.0634 18.5552 13.9715C19.0074 12.8796 19.2402 11.7092 19.2402 10.5273C19.2402 9.34545 19.0074 8.17512 18.5552 7.08319C18.1029 5.99126 17.4399 4.99911 16.6042 4.16338C15.7685 3.32766 14.7763 2.66472 13.6844 2.21243C12.5925 1.76014 11.4221 1.52734 10.2402 1.52734C9.05834 1.52734 7.88801 1.76014 6.79608 2.21243C5.70415 2.66472 4.712 3.32766 3.87627 4.16338C3.04055 4.99911 2.37761 5.99126 1.92532 7.08319C1.47303 8.17512 1.24023 9.34545 1.24023 10.5273Z" stroke="#E30000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <p>Yay! You saved $30 on this booking</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="btmFlightListWrapFixed">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <div className="totalAmtWrap">
                                    <div className="totlAmtLeftWrap">
                                        <h4> Total Amount :   <span> $139 </span></h4>
                                        <p>4 Travellers</p>
                                    </div>
                                    <div className="rightCtasWrap">
                                        <button className="btn" onClick={() => saveFlightBookingDetails()}>
                                            Procced To Pay
                                            <svg width="6" height="16" viewBox="0 0 8 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.51172 1.89062L6.94029 11.3906L1.51172 20.8906" stroke="white" strokeWidth="1.80952" strokeLinecap="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer></Footer>
        </>
    );
}
export default FlightsPay;